module.exports = __webpack_public_path__ + "img/BannerNewMobile.1cf4a51f.png";